import script from "./Collaboration&AddingTeamMembersView.vue?vue&type=script&setup=true&lang=js"
export * from "./Collaboration&AddingTeamMembersView.vue?vue&type=script&setup=true&lang=js"

import "./Collaboration&AddingTeamMembersView.vue?vue&type=style&index=0&id=96104c12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96104c12"]])

export default __exports__